/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { SitesAutocomplete } from 'components/Autocomplete';
import TextEditor from 'components/TextEditor';
import { Toast } from 'components/Toast';
import { EPageTemplate } from 'enums/pageTemplate.enum';
import React, { useState } from 'react';
import { getFriendlyErrorMessage } from '../../../utils/errorHelper';
import useStyles from './styles';

interface IPageFormProps {
  data?: any;
  mutateData: any;
  publishPageToFalcon?: any;
  setIsDrawerOpen?: any;
}

const PageForm: React.FC<IPageFormProps> = ({
  data,
  mutateData,
  publishPageToFalcon,
  setIsDrawerOpen,
}) => {
  const classes = useStyles();

  const [title, setTitle] = useState(data?.title || '');
  const [siteDomain, setSiteDomain] = useState(data?.siteDomain || '');
  const [content, setContent] = useState(data?.content || '');
  const [template, setTemplate] = useState(data?.template || '');

  const handleChange = (
    set: React.Dispatch<any>,
    event: React.ChangeEvent<any>,
  ) => {
    set(event.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    const values = {
      id: data?.id,
      title,
      siteDomain,
      content,
      template,
    };

    mutateData({
      variables: values,
    }).then(
      () => {
        Toast('Action executed with success!');

        setIsDrawerOpen(false);
      },
      (error: any) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  const handlePublish = () => {
    // eslint-disable-next-line no-unused-expressions
    publishPageToFalcon?.({
      variables: { id: data?.id },
    }).then(
      () => {
        Toast('Published with success!');

        setIsDrawerOpen(false);
      },
      (error: any) => {
        Toast(getFriendlyErrorMessage(error), 'error');
      },
    );
  };

  return (
    <form id="myForm" onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        <SitesAutocomplete
          setSelectedSite={setSiteDomain}
          selectedSite={siteDomain}
        />

        <Grid
          item
          className={classes.actionButtons}
          xs={publishPageToFalcon ? 1 : 2}
        >
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.btnSave}
          >
            Save
          </Button>
        </Grid>

        {publishPageToFalcon && (
          <Grid item className={classes.actionButtons} xs={1}>
            <Button
              type="button"
              fullWidth
              variant="contained"
              className={classes.btnPublish}
              onClick={handlePublish}
            >
              Publish
            </Button>
          </Grid>
        )}

        <Grid item xs={12}>
          <TextField
            id="title"
            label="title"
            color="primary"
            onChange={(e) => handleChange(setTitle, e)}
            value={title}
            fullWidth
            className={classes.inputLabel}
            InputLabelProps={{ shrink: true }}
            placeholder=""
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>TEMPLATE</InputLabel>
          <Select
            fullWidth
            id="template"
            onChange={(e) => handleChange(setTemplate, e)}
            value={template}
          >
            <MenuItem value={EPageTemplate.Page}>Page</MenuItem>
            <MenuItem value={EPageTemplate.Contact}>Contact</MenuItem>
            <MenuItem value={EPageTemplate.ErrorPage}>Error Page</MenuItem>
          </Select>
        </Grid>

        <Grid item xs={12}>
          <InputLabel
            className={classes.inputLabel}
            style={{ marginBottom: '8px' }}
          >
            CONTENT
          </InputLabel>
          <TextEditor
            content={content}
            setContent={setContent}
            errorContent={false}
            siteDomain={siteDomain}
            dynamicFieldsList=""
            dynamicFieldsConfig={{ showDynamicFields: false }}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default PageForm;
